import React from "react";
import { PetakSawah } from "./games/PetakSawah";
import { JalanRayaIdle } from "./games/JalanRaya";

// Latar tempat kerja (placeholder kerangka, akan diperkaya saat brainstorming tiap profesi).
// Langit + awan dibagi bersama; bagian tanah/gedung berbeda tiap profesi. SVG mengisi lebar layar, menempel ke bawah.
const LANGIT = {
  petani: ["#bfe0f3", "#eaf5fb"], tukang: ["#c9dff0", "#f1f0e8"], barista: ["#f4ead9", "#f8f3e8"], ojol: ["#bcd9ef", "#edf3f6"], polisi: ["#c3def2", "#eef4f8"],
};

function Awan({ x, y, s = 1 }) {
  return <g transform={`translate(${x} ${y}) scale(${s})`} fill="#fff" opacity=".92"><ellipse cx="0" cy="0" rx="34" ry="14" /><ellipse cx="-18" cy="4" rx="20" ry="11" /><ellipse cx="20" cy="5" rx="22" ry="12" /></g>;
}

// Dataran isometrik (bidang datar seperti peta kota) dengan garis grid 2:1 samar; `cakrawala` = elemen jauh di atas garis horizon y=62
function Dataran({ warna = "#8fcb70", cakrawala, children }) {
  return (
    <>
      {cakrawala}
      <rect x="0" y="62" width="400" height="338" fill={warna} />
      <clipPath id="jw-dataran"><rect x="0" y="62" width="400" height="338" /></clipPath>
      <g clipPath="url(#jw-dataran)" stroke="rgba(0,0,0,.06)" strokeWidth="1">
        {Array.from({ length: 24 }, (_, i) => -200 + i * 27.5).map(y0 => <path key={`a${y0}`} d={`M0 ${y0} L400 ${y0 + 200}`} />)}
        {Array.from({ length: 24 }, (_, i) => -200 + i * 27.5).map(y0 => <path key={`b${y0}`} d={`M400 ${y0} L0 ${y0 + 200}`} />)}
      </g>
      {children}
    </>
  );
}
const Pohon = ({ x, y, s = 1 }) => <g transform={`translate(${x} ${y}) scale(${s})`}><ellipse cy="2" rx="14" ry="5" fill="rgba(0,0,0,.15)" /><rect x="-2.5" y="-14" width="5" height="16" fill="#7a4e26" /><circle cy="-22" r="13" fill="#4f9a4a" /><circle cx="-8" cy="-14" r="9" fill="#5fae4e" /><circle cx="8" cy="-14" r="9" fill="#5fae4e" /></g>;
const ISO_DATARAN = new Set(["petani"]);

const TANAH = {
  petani: (
    <Dataran cakrawala={<>
      <path d="M0 52 Q50 28 110 50 T230 46 T330 42 T400 52 V62 H0 Z" fill="#b7cfc0" />
      <path d="M0 58 Q40 50 80 58 T160 57 T240 58 T320 56 T400 58 V66 H0 Z" fill="#6fae60" />
    </>}>
      {/* jalan tanah */}
      <path d="M0 356 L0 380 L400 180 L400 158 Z" fill="#c9a876" opacity=".9" />
      <path d="M0 368 L400 168" stroke="#b58f5c" strokeWidth="1.5" strokeDasharray="6 10" fill="none" />
      {[[88, 84, .8], [300, 88, .9], [352, 108, 1], [40, 120, 1]].map(([x, y, s], i) => <Pohon key={i} x={x} y={y} s={s} />)}
      <g transform="translate(104 124)"><ellipse cy="12" rx="34" ry="9" fill="rgba(0,0,0,.14)" /><path d="M-30 -6 L0 -30 L30 -6 Z" fill="#b8742d" /><path d="M-24 -6 H24 V8 H-24 Z" fill="#d9b57a" /><rect x="-20" y="-6" width="4" height="16" fill="#8a5a2b" /><rect x="16" y="-6" width="4" height="16" fill="#8a5a2b" /></g>
    </Dataran>
  ),
  tukang: (
    <>
      <path d="M0 205 H400 V400 H0 Z" fill="#d9d4c3" />
      <g fill="#aeb7c2" opacity=".9"><rect x="20" y="120" width="40" height="90" /><rect x="70" y="95" width="30" height="115" /><rect x="300" y="110" width="45" height="100" /><rect x="350" y="140" width="40" height="70" /></g>
      <g transform="translate(150 60)"><rect x="0" y="40" width="120" height="150" fill="#e9e4d4" stroke="#8a8776" strokeWidth="3" /><g stroke="#c27a1c" strokeWidth="3"><path d="M0 80 H120 M0 120 H120 M0 160 H120 M30 40 V190 M60 40 V190 M90 40 V190" /></g><rect x="-10" y="150" width="140" height="6" fill="#c27a1c" /><rect x="-10" y="110" width="140" height="6" fill="#c27a1c" /><rect x="-10" y="70" width="140" height="6" fill="#c27a1c" /></g>
      <g stroke="#55606e" strokeWidth="5" fill="none"><path d="M290 205 V20 H180" /><path d="M180 20 V40" /><circle cx="180" cy="48" r="6" fill="#c27a1c" stroke="none" /></g>
    </>
  ),
  barista: (
    <>
      <rect x="0" y="0" width="400" height="400" fill="#f1e6d2" />
      <rect x="40" y="60" width="120" height="110" rx="10" fill="#cfe6f4" stroke="#fff" strokeWidth="6" />
      <g stroke="#fff" strokeWidth="5"><path d="M100 60 V170 M40 115 H160" /></g>
      <g transform="translate(250 90)"><rect x="0" y="0" width="110" height="60" rx="6" fill="#fff" /><g stroke="#e5ddc9" strokeWidth="2"><path d="M0 20 H110 M0 40 H110" /></g>{[12, 40, 68, 96].map(x => <ellipse key={x} cx={x} cy="12" rx="9" ry="5" fill="#8a5a3c" />)}</g>
      <rect x="0" y="230" width="400" height="170" fill="#8a5a3c" /><rect x="0" y="222" width="400" height="14" fill="#a9734e" />
      <g transform="translate(60 180)"><rect x="0" y="0" width="60" height="42" rx="8" fill="#141414" /><rect x="8" y="-10" width="44" height="14" rx="4" fill="#3b3b3b" /><circle cx="48" cy="20" r="5" fill="#0000CD" /></g>
      {[200, 250, 300].map((x, i) => <g key={x} transform={`translate(${x} 195)`}><path d="M0 0 H28 L24 26 H4 Z" fill="#fff" /><path d="M28 6 q12 2 0 14" stroke="#fff" strokeWidth="4" fill="none" /><path d={`M8 -6 q3 -6 0 -12 M16 -4 q3 -6 0 -12`} stroke="#d9d4c3" strokeWidth="2" fill="none" opacity={.6 + i * .1} /></g>)}
    </>
  ),
  polisi: (
    <>
      <path d="M0 190 H400 V400 H0 Z" fill="#9ed47f" />
      <path d="M0 260 H400 V400 H0 Z" fill="#e4e1d4" />
      <g stroke="#d6d2c2" strokeWidth="2">{[290, 320, 350, 380].map(y => <path key={y} d={`M0 ${y} H400`} />)}{[80, 160, 240, 320].map(x => <path key={x} d={`M${x} 260 V400`} />)}</g>
      {[40, 360].map(x => <g key={x} transform={`translate(${x} 190)`}><rect x="-4" y="0" width="8" height="40" fill="#8a5a2b" /><circle cx="0" cy="-10" r="30" fill="#5fae4e" /><circle cx="-16" cy="4" r="20" fill="#6fb95a" /><circle cx="16" cy="4" r="20" fill="#6fb95a" /></g>)}
      <g transform="translate(200 150)"><rect x="-30" y="100" width="60" height="14" fill="#cfcabd" /><rect x="-20" y="60" width="40" height="40" fill="#f4f1e6" stroke="#cfcabd" strokeWidth="2" /><path d="M-10 60 V0 H10 V60 Z" fill="#f4f1e6" stroke="#cfcabd" strokeWidth="2" /><path d="M-10 0 L0 -22 L10 0 Z" fill="#0000CD" /></g>
      <g transform="translate(300 300)"><rect x="-26" y="-6" width="52" height="12" rx="6" fill="#141414" /><rect x="-6" y="6" width="12" height="40" fill="#555" /><rect x="-22" y="-24" width="44" height="18" rx="4" fill="#dc2626" /><rect x="-22" y="-24" width="22" height="18" rx="4" fill="#0000CD" /></g>
    </>
  ),
};

export function Scene({ profesi = "petani", idle = true }) {
  const [a, b] = LANGIT[profesi] || LANGIT.petani;
  // Ojol: jalan raya top-down (saat bermain, game menggambar jalannya sendiri di atas latar ini)
  if (profesi === "ojol") return <div data-testid="scene-ojol" style={{ position: "absolute", inset: 0, background: "#9bd27a" }}>{idle && <JalanRayaIdle />}</div>;
  return (
    <div data-testid={`scene-${profesi}`} style={{ position: "absolute", inset: 0, background: `linear-gradient(${a}, ${b} 55%)`, overflow: "hidden" }}>
      <style>{`@keyframes jw-awan{0%{transform:translateX(0)}100%{transform:translateX(40px)}}`}</style>
      {profesi !== "barista" && (
        <svg viewBox="0 0 400 200" preserveAspectRatio="xMidYMin slice" style={{ position: "absolute", left: 0, right: 0, top: 0, width: "100%", height: "48%" }}>
          <circle cx="330" cy="70" r="26" fill="#ffd66b" opacity=".95" />
          <g style={{ animation: "jw-awan 18s ease-in-out infinite alternate" }}><Awan x={80} y={70} /><Awan x={260} y={110} s={.8} /></g>
        </svg>
      )}
      <svg viewBox="0 0 400 400" preserveAspectRatio="xMidYMax slice" style={{ position: "absolute", left: 0, right: 0, bottom: 0, width: "100%", height: ISO_DATARAN.has(profesi) ? "78%" : "72%" }}>
        {TANAH[profesi] || TANAH.petani}
      </svg>
      {idle && profesi === "petani" && <PetakSawah />}
    </div>
  );
}
